/*
 * Display formatting for /ai, in the device locale and timezone (the calendar
 * the athlete is living in). `now` is injectable for tests.
 */

export const MAX_MESSAGE_CHARS = 1000;
export const MAX_MEMORY_CHARS = 160;
export const MAX_CHECKIN_NOTE_CHARS = 300;

// The server counts code points after trimming (contract §3).
export function countChars(text) {
  return [...String(text || "").trim()].length;
}

function startOfDay(date) {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate());
}

const DAY_MS = 24 * 60 * 60 * 1000;

export function formatDayLabel(iso, now = new Date()) {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return "";
  const days = Math.round((startOfDay(now) - startOfDay(date)) / DAY_MS);
  if (days === 0) return "Today";
  if (days === 1) return "Yesterday";
  const sameYear = date.getFullYear() === now.getFullYear();
  return date.toLocaleDateString(undefined, {
    weekday: days < 7 ? "long" : undefined,
    month: "short",
    day: "numeric",
    year: sameYear ? undefined : "numeric",
  });
}

export function formatTime(iso) {
  const date = new Date(iso);
  return Number.isNaN(date.getTime())
    ? ""
    : date.toLocaleTimeString(undefined, { hour: "numeric", minute: "2-digit" });
}

// "at 7:00 PM" today, "tomorrow at 7:00 PM", else a date.
export function formatResetsAt(iso, now = new Date()) {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return "tomorrow";
  const days = Math.round((startOfDay(date) - startOfDay(now)) / DAY_MS);
  const time = formatTime(iso);
  if (days <= 0) return `at ${time}`;
  if (days === 1) return `tomorrow at ${time}`;
  return `on ${date.toLocaleDateString(undefined, { month: "short", day: "numeric" })} at ${time}`;
}

// "YYYY-MM-DD" → "Nov 20" (a calendar day, no timezone shift).
export function formatCalendarDay(day) {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(day || ""));
  if (!match) return "";
  const date = new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
  return date.toLocaleDateString(undefined, { month: "short", day: "numeric" });
}

export function todayKey(now = new Date()) {
  const pad = (value) => String(value).padStart(2, "0");
  return `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`;
}
